<template>
  <el-dialog :title="title" :visible.sync="visible" width="1100px" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeFn">
    <slot name="bar"></slot>
    <div class="padding-15">
      <el-row v-if="newChartData" v-loading="chartLoading">
        <el-col :span="24">
          <echarts :data="newChartData" title="" height="300" :nohader="true"></echarts>
        </el-col>
      </el-row>
    </div>
    <div class="padding-15 auto">
      <el-row v-if="newTableHead" v-loading="tableLoading">
        <el-col :span="24">
          <detail-dialog-table-temp :tableHead="newTableHead" :tableData="tablePageData" :title="false" :customSort="true" @tableSortChange="tableSortChange"></detail-dialog-table-temp>
          <div class="pageBox" v-if="tableData.length > pageSize">
            <el-pagination
              layout="prev, pager, next"
              :page-size="pageSize"
              @current-change="tablePage"
              :current-page.sync="currentPage"
              :total="tableData.length"
              align="right">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'detailDialog',
  props: [
    'title',
    'dialogVisible',
    'chartData',
    'tableHead',
    'tableData',
    'status'
  ],
  data () {
    return {
      newChartData: {},
      visible: this.dialogVisible,
      newTableHead: this.tableHead,
      newTableData: this.tableData,
      pageSize: 10,
      currentPage: 1,
      tablePageData: [],
      chartLoading: true,
      tableLoading: true
    }
  },
  watch: {
    'chartData': function (val) {
      // this.newChartData = val
      if (val) {
        this.$nextTick(() => {
          this.newChartData = JSON.parse(JSON.stringify(val))
        })
      } else {
        this.newChartData = false
      }
      this.chartLoading = false
    },
    'status': function (val) {
      this.chartLoading = true
      this.tableLoading = true
    },
    'dialogVisible': function (val) {
      this.visible = val
      if (val) {
        this.$nextTick(() => {
          this.newChartData = this.chartData
        })
      }
    },
    'tableHead': function (val) {
      this.newTableHead = val
    },
    'tableData': function (val) {
      this.tableLoading = false
      this.tablePage(1)
      this.currentPage = 1
    }
  },
  methods: {
    tableSortChange (params) {
      this.$emit('tableSortChange', params)
    },
    tablePage (val) {
      this.tablePageData = []
      this.tableData.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.tablePageData.push(item)
        }
      })
      // console.log(this.tablePageData)
    },
    closeFn () {
      this.$emit('visibleFn', false)
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped>
.pageBox{
  margin: 20px 0;
}
</style>
